import { SvgIcon } from '@material-ui/core'
import React, { forwardRef } from 'react'

const EBSVolume = forwardRef((props, ref) => {
  return (
    <SvgIcon ref={ref} viewBox='0 0 40 40' {...props}>
      <svg className='w-6 h-6' height='40' width='40' xmlns='http://www.w3.org/2000/svg'>
        <defs>
          <linearGradient x1='0%' y1='100%' x2='100%' y2='0%' id='Arch_Amazon-Elastic-Block-Store_32_svg__a'>
            <stop stop-color='#1B660F' offset='0%' />
            <stop stop-color='#6CAE3E' offset='100%' />
          </linearGradient>
        </defs>
        <g fill='none' fill-rule='evenodd'>
          <path d='M0 0h40v40H0z' fill='url(#Arch_Amazon-Elastic-Block-Store_32_svg__a)' />
          <path
            d='M33 28h1v6h-6v-1h4.293l-4.647-4.646.708-.708L33 32.293V28zm-19.646.354L8.707 33H13v1H7v-6h1v4.293l4.646-4.647.708.708zM34 6v6h-1V7.707l-4.646 4.647-.708-.708L32.293 7H28V6h6zM8.707 7l4.647 4.646-.708.708L8 7.707V12H7V6h6v1H8.707zM20.5 15.5c-3.572 0-5.5-1.04-5.5-1.464V14c0-.626 2.093-1.5 5.5-1.5s5.5.874 5.5 1.5v.036c0 .424-1.928 1.464-5.5 1.464zm0 12c-3.407 0-5.5-.874-5.5-1.5V15.389c1.228.727 3.404 1.111 5.5 1.111s4.272-.384 5.5-1.111V26c0 .626-2.093 1.5-5.5 1.5zm0-16c-3.235 0-6.5.773-6.5 2.5v12c0 1.727 3.265 2.5 6.5 2.5S27 27.727 27 26V14c0-1.727-3.265-2.5-6.5-2.5z'
            fill='#FFF'
          />
        </g>
      </svg>
    </SvgIcon>
  )
})

export default EBSVolume
